<section
  [ngClass]="{
    'section--public background--wave': type === 'public'
  }"
>
  <div [class.public--content]="type === 'public'">
    <div class="component-container">
      <div class="text-center relative">
        <img
          src="assets/assets-site/images/svg-illustrations/404.svg"
          alt=""
          class="w-full block mx-auto max-w-[800px]"
        />
      </div>
    </div>
  </div>
</section>
